import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ExternalClientRequestDto {
  name: string;
  clientTypeId: number;
}

export interface ExternalClientResponseDto {
  id: number;
  name: string;
  apiKey: string;
  keyPrefix: string;
  active: boolean;
  typeId: number | null;
  typeName: string | null;
  createdAt: string;
}

export interface ExternalClientListItemDto {
  id: number;
  name: string;
  active: boolean;
  typeId: number | null;
  typeName: string | null;
  keyPrefix: string;
  createdAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class ExternalClientService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  list(): Observable<ExternalClientListItemDto[]> {
    const url = `${this.apiUrl}/sicred/api/v1/externalclients`;
    return this.http.get<ExternalClientListItemDto[]>(url, {
      withCredentials: true,
    });
  }

  create(request: ExternalClientRequestDto): Observable<ExternalClientResponseDto> {
    const url = `${this.apiUrl}/sicred/api/v1/externalclients`;
    return this.http.post<ExternalClientResponseDto>(url, request, {
      withCredentials: true,
    });
  }

  deactivate(id: number): Observable<void> {
    const url = `${this.apiUrl}/sicred/api/v1/externalclients/${id}/deactivate`;
    return this.http.patch<void>(url, null, {
      withCredentials: true,
    });
  }
}
